/** @flow */
// Absence now
export const GetAbsenceNow = "GET_ABSENCE_NOW";
export const GetAbsenceNowSuccess = "GET_ABSENCE_NOW_SUCCESS";
export const GetAbsenceNowError = "GET_ABSENCE_NOW_ERROR";

// Hierarchy Breakdown
export const GetHierarchyBreakdown = "GET_HIERARCHY_BREAKDOWN";
export const GetHierarchyBreakdownSuccess = "GET_HIERARCHY_BREAKDOWN_SUCCESS";
export const GetHierarchyBreakdownError = "GET_HIERARCHY_BREAKDOWN_ERROR";

// Tools Dashboard
export const GetLoggedUserDashboardOverview = "GET_LOGGED_USER_DASHBOARD_OVERVIEW";
export const GetLoggedUserDashboardOverviewSuccess = "GET_LOGGED_USER_DASHBOARD_OVERVIEW_SUCCESS";
export const GetLoggedUserDashboardOverviewError = "GET_LOGGED_USER_DASHBOARD_OVERVIEW_ERROR";
export const GetToolsDashboard = "GET_TOOLS_DASHBOARD";
export const GetToolsDashboardSuccess = "GET_TOOLS_DASHBOARD_SUCCESS";
export const GetToolsDashboardError = "GET_TOOLS_DASHBOARD_ERROR";
export const GetFirstCareIndexPageStatistic = "GET_FIRSTCARE_INDEX_PAGE_STATISTIC";
export const GetFirstCareIndexPageStatisticSuccess = "GET_FIRSTCARE_INDEX_PAGE_STATISTIC_SUCCESS";
export const GetFirstCareIndexPageStatisticError = "GET_FIRSTCARE_INDEX_PAGE_STATISTIC_ERROR";
export const GetCoronavirusToolsDashboard = "GET_CORONAVIRUS_TOOLS_DASHBOARD";
export const GetCoronavirusToolsDashboardSuccess = "GET_CORONAVIRUS_TOOLS_DASHBOARD_SUCCESS";
export const GetCoronavirusToolsDashboardError = "GET_CORONAVIRUS_TOOLS_DASHBOARD_ERROR";
// Activity Feed Dashboard
export const GetActivityFeedDashboard = "GET_ACTIVITY_FEED_DASHBOARD";
export const GetActivityFeedDashboardError = "GET_ACTIVITY_FEED_DASHBOARD_ERROR";
export const GetActivityFeedDashboardSuccess = "GET_ACTIVITY_FEED_DASHBOARD_SUCCESS";
// Recent/Today's Activity Feed Dashboard
export const GetRecentActivityFeedDashboard = "GET_RECENT_ACTIVITY_FEED_DASHBOARD_DASHBOARD";
export const GetRecentActivityFeedDashboardError = "GET_RECENT_ACTIVITY_FEED_DASHBOARD_ERROR";
export const GetRecentActivityFeedDashboardSuccess = "GET_RECENT_ACTIVITY_FEED_DASHBOARD_SUCCESS";

// Reports Absence Monitoring Details
export const GetReportingAbsenceMonitoringDefaultReports =
  "REPORTING_ABSENCE_MONITORING_DEFAULT_REPORTS_REQUEST";
export const GetReportingAbsenceMonitoringDefaultReportsSuccess =
  "REPORTING_ABSENCE_MONITORING_DEFAULT_REPORTS_SUCCESS";
export const GetReportingAbsenceMonitoringDefaultReportsError =
  "REPORTING_ABSENCE_MONITORING_DEFAULT_REPORTS_ERROR";
export const GetReportingAbsenceMonitoringMyReports =
  "REPORTING_ABSENCE_MONITORING_MY_REPORTS_REQUEST";
export const GetReportingAbsenceMonitoringMyReportsSuccess =
  "REPORTING_ABSENCE_MONITORING_MY_REPORTS_SUCCESS";
export const GetReportingAbsenceMonitoringMyReportsError =
  "REPORTING_ABSENCE_MONITORING_MY_REPORTS_ERROR";
export const GetReportingAbsenceMonitoringReport = "REPORTING_ABSENCE_MONITORING_REPORT_REQUEST";
export const GetReportingAbsenceMonitoringReportSuccess =
  "REPORTING_ABSENCE_MONITORING_REPORT_SUCCESS";
export const GetReportingAbsenceMonitoringReportError = "REPORTING_ABSENCE_MONITORING_REPORT_ERROR";
export const GetReportingAbsenceMonitoringCharts = "REPORTING_ABSENCE_MONITORING_CHARTS_REQUEST";
export const GetReportingAbsenceMonitoringChartsSuccess =
  "REPORTING_ABSENCE_MONITORING_CHARTS_SUCCESS";
export const GetReportingAbsenceMonitoringChartsError = "REPORTING_ABSENCE_MONITORING_CHARTS_ERROR";
export const GetAbsenceMonitoringFiltersSchema = "GET_ABSENCE_MONITORING_FILTERS_SCHEMA";
export const GetAbsenceMonitoringFiltersSchemaSuccess =
  "GET_ABSENCE_MONITORING_FILTERS_SCHEMA_SUCCESS";
export const GetAbsenceMonitoringFiltersSchemaError = "GET_ABSENCE_MONITORING_FILTERS_SCHEMA_ERROR";
export const CreateAbsenceMonitoringReport = "CREATE_ABSENCE_MONITORING_REPORT";
export const CreateAbsenceMonitoringReportSuccess = "CREATE_ABSENCE_MONITORING_REPORT_SUCCESS";
export const CreateAbsenceMonitoringReportError = "CREATE_ABSENCE_MONITORING_REPORT_ERROR";
export const UpdateAbsenceMonitoringReport = "UPDATE_ABSENCE_MONITORING_REPORT";
export const UpdateAbsenceMonitoringReportSuccess = "UPDATE_ABSENCE_MONITORING_REPORT_SUCCESS";
export const UpdateAbsenceMonitoringReportError = "UPDATE_ABSENCE_MONITORING_REPORT_ERROR";
export const ExportAbsenceMonitoringReport = "EXPORT_ABSENCE_MONITORING_REPORT";
export const ExportAbsenceMonitoringReportSuccess = "EXPORT_ABSENCE_MONITORING_REPORT_SUCCESS";
export const ExportAbsenceMonitoringReportError = "EXPORT_ABSENCE_MONITORING_REPORT_ERROR";
export const DeleteAbsenceMonitoringReport = "DELETE_ABSENCE_MONITORING_REPORT";
export const DeleteAbsenceMonitoringReportSuccess = "DELETE_ABSENCE_MONITORING_REPORT_SUCCESS";
export const DeleteAbsenceMonitoringReportError = "DELETE_ABSENCE_MONITORING_REPORT_ERROR";
export const SetAbsenceMonitoringReportToSave = "SET_ABSENCE_MONITORING_REPORT_TO_SAVE";
export const ReSetAbsenceMonitoringReportToSave = "RE_SET_ABSENCE_MONITORING_REPORT_TO_SAVE";
export const SetAbsenceMonitoringReportViewState = "SET_ABSENCE_MONITORING_REPORT_VIEW_STATE";

// Reports RTW Details
export const GetReportingRTWDetailsDefaultReports = "REPORTING_RTW_DEFAULT_REPORTS_REQUEST";
export const GetReportingRTWDetailsDefaultReportsSuccess = "REPORTING_RTW_DEFAULT_REPORTS_SUCCESS";
export const GetReportingRTWDetailsDefaultReportsError = "REPORTING_RTW_DEFAULT_REPORTS_ERROR";
export const GetReportingRTWDetailsMyReports = "REPORTING_RTW_MY_REPORTS_REQUEST";
export const GetReportingRTWDetailsMyReportsSuccess = "REPORTING_RTW_MY_REPORTS_SUCCESS";
export const GetReportingRTWDetailsMyReportsError = "REPORTING_RTW_MY_REPORTS_ERROR";
export const SetReportingRTWDetailsCurrentReport = "SET_REPORTING_RTW_DETAILS_REPORT";
export const GetReportingRTWDetailsReport = "GET_REPORTING_RTW_DETAILS_REPORT";
export const GetReportingRTWDetailsReportSuccess = "GET_REPORTING_RTW_DETAILS_REPORT_SUCCESS";
export const GetReportingRTWDetailsReportError = "GET_REPORTING_RTW_DETAILS_REPORT_ERROR";
export const GetReportingRTWDetailsCharts = "REPORTING_RTW_CHARTS_REQUEST";
export const GetReportingRTWDetailsChartsSuccess = "REPORTING_RTW_CHARTS_SUCCESS";
export const GetReportingRTWDetailsChartsError = "REPORTING_RTW_CHARTS_ERROR";
export const GetRTWDetailsFiltersSchema = "GET_RTW_DETAILS_FILTERS_SCHEMA";
export const GetRTWDetailsFiltersSchemaSuccess = "GET_RTW_DETAILS_FILTERS_SCHEMA_SUCCESS";
export const GetRTWDetailsFiltersSchemaError = "GET_RTW_DETAILS_FILTERS_SCHEMA_ERROR";
export const CreateRTWDetailsReport = "CREATE_RTW_DETAILS_REPORT";
export const CreateRTWDetailsReportSuccess = "CREATE_RTW_DETAILS_REPORT_SUCCESS";
export const CreateRTWDetailsReportError = "CREATE_RTW_DETAILS_REPORT_ERROR";
export const UpdateRTWDetailsReport = "UPDATE_RTW_DETAILS_REPORT";
export const UpdateRTWDetailsReportSuccess = "UPDATE_RTW_DETAILS_REPORT_SUCCESS";
export const UpdateRTWDetailsReportError = "UPDATE_RTW_DETAILS_REPORT_ERROR";
export const DeleteRTWDetailsReport = "DELETE_RTW_DETAILS_REPORT";
export const DeleteRTWDetailsReportSuccess = "DELETE_RTW_DETAILS_REPORT_SUCCESS";
export const DeleteRTWDetailsReportError = "DELETE_RTW_DETAILS_REPORT_ERROR";
export const ExportRTWDetailsReport = "EXPORT_RTW_DETAILS_REPORT";
export const ExportRTWDetailsReportSuccess = "EXPORT_RTW_DETAILS_REPORT_SUCCESS";
export const ExportRTWDetailsReportError = "EXPORT_RTW_DETAILS_REPORT_ERROR";
export const SetRTWDetailsReportToSave = "SET_RTW_DETAILS_REPORT_TO_SAVE";
export const ReSetRTWDetailsReportToSave = "RE_SET_RTW_DETAILS_REPORT_TO_SAVE";
export const SetRtwDetailsReportViewState = "SET_RTW_DETAILS_REPORT_VIEW_STATE";
export const ToggleRtwInterviewModal = "TOGGLE_RTW_INTERVIEW_MODAL";
export const GetRTWDetailsReportAbsenceRTWInterview =
  "GET_RTW_DETAILS_REPORT_ABSENCE_RTW_INTERVIEW";
export const GetRTWDetailsReportAbsenceRTWInterviewSuccess =
  "GET_RTW_DETAILS_REPORT_ABSENCE_RTW_INTERVIEW_SUCCESS";
export const GetRTWDetailsReportAbsenceRTWInterviewError =
  "GET_RTW_DETAILS_REPORT_ABSENCE_RTW_INTERVIEW_ERROR";

// Reports Alert Details
export const GetReportingAlertDetailsDefaultReports = "REPORTING_ALERT_DEFAULT_REPORTS_REQUEST";
export const GetReportingAlertDetailsDefaultReportsSuccess =
  "REPORTING_ALERT_DEFAULT_REPORTS_SUCCESS";
export const GetReportingAlertDetailsDefaultReportsError = "REPORTING_ALERT_DEFAULT_REPORTS_ERROR";
export const GetReportingAlertDetailsMyReports = "REPORTING_ALERT_MY_REPORTS_REQUEST";
export const GetReportingAlertDetailsMyReportsSuccess = "REPORTING_ALERT_MY_REPORTS_SUCCESS";
export const GetReportingAlertDetailsMyReportsError = "REPORTING_ALERT_MY_REPORTS_ERROR";
export const SetAlertDetailsCurrentReport = "SET_ALERT_DETAILS_CURRENT_REPORT";
export const GetReportingAlertDetailsReport = "GET_REPORTING_ALERT_DETAILS_REPORT";
export const GetReportingAlertDetailsReportSuccess = "GET_REPORTING_ALERT_DETAILS_REPORT_SUCCESS";
export const GetReportingAlertDetailsReportError = "GET_REPORTING_ALERT_DETAILS_REPORT_ERROR";
export const GetReportingAlertDetailsDefaultReport = "REPORTING_ALERT_DEFAULT_REPORT_REQUEST";
export const GetReportingAlertDetailsDefaultReportSuccess =
  "REPORTING_ALERT_DEFAULT_REPORT_SUCCESS";
export const GetReportingAlertDetailsDefaultReportError = "REPORTING_ALERT_DEFAULT_REPORT_ERROR";
export const GetReportingAlertDetailsCharts = "REPORTING_ALERT_CHARTS_REQUEST";
export const GetReportingAlertDetailsChartsSuccess = "REPORTING_ALERT_CHARTS_SUCCESS";
export const GetReportingAlertDetailsChartsError = "REPORTING_ALERT_CHARTS_ERROR";
export const GetAlertDetailsFiltersSchema = "GET_ALERT_DETAILS_FILTERS_SCHEMA";
export const GetAlertDetailsFiltersSchemaSuccess = "GET_ALERT_DETAILS_FILTERS_SCHEMA_SUCCESS";
export const GetAlertDetailsFiltersSchemaError = "GET_ALERT_DETAILS_FILTERS_SCHEMA_ERROR";
export const CreateAlertDetailsReport = "CREATE_ALERT_DETAILS_REPORT";
export const CreateAlertDetailsReportSuccess = "CREATE_ALERT_DETAILS_REPORT_SUCCESS";
export const CreateAlertDetailsReportError = "CREATE_ALERT_DETAILS_REPORT_ERROR";
export const UpdateAlertDetailsReport = "UPDATE_ALERT_DETAILS_REPORT";
export const UpdateAlertDetailsReportSuccess = "UPDATE_ALERT_DETAILS_REPORT_SUCCESS";
export const UpdateAlertDetailsReportError = "UPDATE_ALERT_DETAILS_REPORT_ERROR";
export const DeleteAlertDetailsReport = "DELETE_ALERT_DETAILS_REPORT";
export const DeleteAlertDetailsReportSuccess = "DELETE_ALERT_DETAILS_REPORT_SUCCESS";
export const DeleteAlertDetailsReportError = "DELETE_ALERT_DETAILS_REPORT_ERROR";
export const SetAlertDetailsReportToSave = "SET_ALERT_DETAILS_REPORT_TO_SAVE";
export const ReSetAlertDetailsReportToSave = "RE_SET_ALERT_DETAILS_REPORT_TO_SAVE";
export const SetAlertDetailsReportViewState = "SET_ALERT_DETAILS_REPORT_VIEW_STATE";
export const ExportAlertDetailsReport = "EXPORT_ALERT_DETAILS_REPORT";
export const ExportAlertDetailsReportSuccess = "EXPORT_ALERT_DETAILS_REPORT_SUCCESS";
export const ExportAlertDetailsReportError = "EXPORT_ALERT_DETAILS_REPORT_ERROR";

// Referral Details
export const GetReportingReferralDetailsDefaultReports =
  "REPORTING_REFERRAL_DEFAULT_REPORTS_REQUEST";
export const GetReportingReferralDetailsDefaultReportsSuccess =
  "REPORTING_REFERRAL_DEFAULT_REPORTS_SUCCESS";
export const GetReportingReferralDetailsDefaultReportsError =
  "REPORTING_REFERRAL_DEFAULT_REPORTS_ERROR";
export const GetReportingReferralDetailsMyReports = "REPORTING_REFERRAL_MY_REPORTS_REQUEST";
export const GetReportingReferralDetailsMyReportsSuccess = "REPORTING_REFERRAL_MY_REPORTS_SUCCESS";
export const GetReportingReferralDetailsMyReportsError = "REPORTING_REFERRAL_MY_REPORTS_ERROR";
export const GetReportingReferralDetailsReport = "REPORTING_REFERRAL_REPORT_REQUEST";
export const GetReportingReferralDetailsReportSuccess = "REPORTING_REFERRAL_REPORT_SUCCESS";
export const GetReportingReferralDetailsReportError = "REPORTING_REFERRAL_REPORT_ERROR";
export const GetReportingReferralDetailsCharts = "REPORTING_REFERRAL_CHARTS_REQUEST";
export const GetReportingReferralDetailsChartsSuccess = "REPORTING_REFERRAL_CHARTS_SUCCESS";
export const GetReportingReferralDetailsChartsError = "REPORTING_REFERRAL_CHARTS_ERROR";
export const GetReferralDetailsFiltersSchema = "GET_REFERRAL_DETAILS_FILTERS_SCHEMA";
export const GetReferralDetailsFiltersSchemaSuccess = "GET_REFERRAL_DETAILS_FILTERS_SCHEMA_SUCCESS";
export const GetReferralDetailsFiltersSchemaError = "GET_REFERRAL_DETAILS_FILTERS_SCHEMA_ERROR";
export const CreateReferralDetailsReport = "CREATE_REFERRAL_DETAILS_REPORT";
export const CreateReferralDetailsReportSuccess = "CREATE_REFERRAL_DETAILS_REPORT_SUCCESS";
export const CreateReferralDetailsReportError = "CREATE_REFERRAL_DETAILS_REPORT_ERROR";
export const UpdateReferralDetailsReport = "UPDATE_REFERRAL_DETAILS_REPORT";
export const UpdateReferralDetailsReportSuccess = "UPDATE_REFERRAL_DETAILS_REPORT_SUCCESS";
export const UpdateReferralDetailsReportError = "UPDATE_REFERRAL_DETAILS_REPORT_ERROR";
export const DeleteReferralDetailsReport = "DELETE_REFERRAL_DETAILS_REPORT";
export const DeleteReferralDetailsReportSuccess = "DELETE_REFERRAL_DETAILS_REPORT_SUCCESS";
export const DeleteReferralDetailsReportError = "DELETE_REFERRAL_DETAILS_REPORT_ERROR";
export const SetReferralDetailsReportToSave = "SET_REFERRAL_DETAILS_REPORT_TO_SAVE";
export const ReSetReferralDetailsReportToSave = "RE_SET_REFERRAL_DETAILS_REPORT_TO_SAVE";

// Reports MI Reports
export const GetReportingMiReportsMyPresentations = "GET_REPORTING_MI_REPORTS_MY_PRESENTATIONS";
export const GetReportingMiReportsMyPresentationsSuccess =
  "GET_REPORTING_MI_REPORTS_MY_PRESENTATIONS_SUCCESS";
export const GetReportingMiReportsMyPresentationsError =
  "GET_REPORTING_MI_REPORTS_MY_PRESENTATIONS_ERROR";
export const GetReportingMiReportsSharedPresentations =
  "GET_REPORTING_MI_REPORTS_SHARED_PRESENTATIONS";
export const GetReportingMiReportsSharedPresentationsSuccess =
  "GET_REPORTING_MI_REPORTS_SHARED_PRESENTATIONS_SUCCESS";
export const GetReportingMiReportsSharedPresentationsError =
  "GET_REPORTING_MI_REPORTS_SHARED_PRESENTATIONS_ERROR";
export const GetReportingMiReportsMiSlides = "GET_REPORTING_MI_REPORTS_MI_SLIDES";
export const GetReportingMiReportsMiSlidesSuccess = "GET_REPORTING_MI_REPORTS_MI_SLIDES_SUCCESS";
export const GetReportingMiReportsMiSlidesError = "GET_REPORTING_MI_REPORTS_MI_SLIDES_ERROR";
export const ReportingMiReportsSelectSlide = "REPORTING_MI_REPORTS_SELECT_SLIDE";
export const GetReportingMiReportsPresentationLogs = "GET_REPORTING_MI_REPORTS_PRESENTATION_LOGS";
export const GetReportingMiReportsPresentationLogsSuccess =
  "GET_REPORTING_MI_REPORTS_PRESENTATION_LOGS_SUCCESS";
export const GetReportingMiReportsPresentationLogsError =
  "GET_REPORTING_MI_REPORTS_PRESENTATION_LOGS_ERROR";
export const MiReportsCreateNewPresentation = "MI_REPORTS_CREATE_NEW_PRESENTATION";
export const MiReportsCreateNewPresentationSuccess = "MI_REPORTS_CREATE_NEW_PRESENTATION_SUCCESS";
export const MiReportsCreateNewPresentationError = "MI_REPORTS_CREATE_NEW_PRESENTATION_ERROR";
export const MiReportsUpdatePresentation = "MI_REPORTS_UPDATE_PRESENTATION";
export const MiReportsUpdatePresentationSuccess = "MI_REPORTS_UPDATE_PRESENTATION_SUCCESS";
export const MiReportsUpdatePresentationError = "MI_REPORTS_UPDATE_PRESENTATION_ERROR";
export const MiReportsEmployeesToShareSearch = "MI_REPORTS_EMPLOYEES_TO_SHARE_SEARCH";
export const MiReportsEmployeesToShareSearchSuccess =
  "MI_REPORTS_EMPLOYEES_TO_SHARE_SEARCH_SUCCESS";
export const MiReportsEmployeesToShareSearchError = "MI_REPORTS_EMPLOYEES_TO_SHARE_SEARCH_ERROR";
export const MiReportsEmployeesToShareClear = "MI_REPORTS_EMPLOYEES_TO_SHARE_CLEAR";
export const MiReportsSharePresentation = "MI_REPORTS_SHARE_PRESENTATION";
export const MiReportsSharePresentationSuccess = "MI_REPORTS_SHARE_PRESENTATION_SUCCESS";
export const MiReportsSharePresentationError = "MI_REPORTS_SHARE_PRESENTATION_ERROR";
export const DownloadMiReportsPresentation = "DOWNLOAD_MI_REPORTS_PRESENTATION";
export const DownloadMiReportsPresentationSuccess = "DOWNLOAD_MI_REPORTS_PRESENTATION_SUCCESS";
export const DownloadMiReportsPresentationError = "DOWNLOAD_MI_REPORTS_PRESENTATION_ERROR";

// Employee Focus Lists
export const GetReportingFocusListsEmployeeDefaultReports =
  "REPORTING_FOCUS_LIST_EMPLOYEE_DEFAULT_REPORTS_REQUEST";
export const GetReportingFocusListsEmployeeDefaultReportsSuccess =
  "REPORTING_FOCUS_LIST_EMPLOYEE_DEFAULT_REPORTS_SUCCESS";
export const GetReportingFocusListsEmployeeDefaultReportsError =
  "REPORTING_FOCUS_LIST_EMPLOYEE_DEFAULT_REPORTS_ERROR";
export const GetReportingFocusListsEmployeeMyReports =
  "REPORTING_FOCUS_LIST_EMPLOYEE_MY_REPORTS_REQUEST";
export const GetReportingFocusListsEmployeeMyReportsSuccess =
  "REPORTING_FOCUS_LIST_EMPLOYEE_MY_REPORTS_SUCCESS";
export const GetReportingFocusListsEmployeeMyReportsError =
  "REPORTING_FOCUS_LIST_EMPLOYEE_MY_REPORTS_ERROR";
export const GetReportingFocusListsEmployeeReport = "REPORTING_FOCUS_LIST_EMPLOYEE_REPORT_REQUEST";
export const GetReportingFocusListsEmployeeReportSuccess =
  "REPORTING_FOCUS_LIST_EMPLOYEE_REPORT_SUCCESS";
export const GetReportingFocusListsEmployeeReportError =
  "REPORTING_FOCUS_LIST_EMPLOYEE_REPORT_ERROR";
export const GetFocusListsEmployeeReportSchema = "GET_FOCUS_LISTS_EMPLOYEE_REPORT_SCHEMA";
export const GetFocusListsEmployeeReportSchemaSuccess =
  "GET_FOCUS_LISTS_EMPLOYEE_REPORT_SCHEMA_SUCCESS";
export const GetFocusListsEmployeeReportSchemaError =
  "GET_FOCUS_LISTS_EMPLOYEE_REPORT_SCHEMA_ERROR";
export const CreateFocusListsEmployeeSavedReport = "CREATE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT";
export const CreateFocusListsEmployeeSavedReportSuccess =
  "CREATE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT_SUCCESS";
export const CreateFocusListsEmployeeSavedReportError =
  "CREATE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT_ERROR";
export const UpdateFocusListsEmployeeSavedReport = "UPDATE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT";
export const UpdateFocusListsEmployeeSavedReportSuccess =
  "UPDATE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT_SUCCESS";
export const UpdateFocusListsEmployeeSavedReportError =
  "UPDATE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT_ERROR";
export const DeleteFocusListsEmployeeSavedReport = "DELETE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT";
export const DeleteFocusListsEmployeeSavedReportSuccess =
  "DELETE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT_SUCCESS";
export const DeleteFocusListsEmployeeSavedReportError =
  "DELETE_FOCUS_LISTS_EMPLOYEE_SAVED_REPORT_ERROR";
export const ExportFocusListsEmployeeReport = "EXPORT_FOCUS_LISTS_EMPLOYEE_REPORT";
export const ExportFocusListsEmployeeReportSuccess = "EXPORT_FOCUS_LISTS_EMPLOYEE_REPORT_SUCCESS";
export const ExportFocusListsEmployeeReportError = "EXPORT_FOCUS_LISTS_EMPLOYEE_REPORT_ERROR";
export const SetFocusListsEmployeeReportToSave = "SET_FOCUS_LISTS_EMPLOYEE_REPORT_TO_SAVE";
export const ReSetFocusListsEmployeeReportToSave = "RE_SET_FOCUS_LISTS_EMPLOYEE_REPORT_TO_SAVE";

// Manager Focus Lists
export const GetReportingFocusListsManagerDefaultReports =
  "REPORTING_FOCUS_LIST_MANAGER_DEFAULT_REPORTS_REQUEST";
export const GetReportingFocusListsManagerDefaultReportsSuccess =
  "REPORTING_FOCUS_LIST_MANAGER_DEFAULT_REPORTS_SUCCESS";
export const GetReportingFocusListsManagerDefaultReportsError =
  "REPORTING_FOCUS_LIST_MANAGER_DEFAULT_REPORTS_ERROR";
export const GetReportingFocusListsManagerMyReports =
  "REPORTING_FOCUS_LIST_MANAGER_MY_REPORTS_REQUEST";
export const GetReportingFocusListsManagerMyReportsSuccess =
  "REPORTING_FOCUS_LIST_MANAGER_MY_REPORTS_SUCCESS";
export const GetReportingFocusListsManagerMyReportsError =
  "REPORTING_FOCUS_LIST_MANAGER_MY_REPORTS_ERROR";
export const GetReportingFocusListsManagerReport = "REPORTING_FOCUS_LIST_MANAGER_REPORT_REQUEST";
export const GetReportingFocusListsManagerReportSuccess =
  "REPORTING_FOCUS_LIST_MANAGER_REPORT_SUCCESS";
export const GetReportingFocusListsManagerReportError = "REPORTING_FOCUS_LIST_MANAGER_REPORT_ERROR";
export const GetFocusListsManagerReportSchema = "GET_FOCUS_LISTS_MANAGER_REPORT_SCHEMA";
export const GetFocusListsManagerReportSchemaSuccess =
  "GET_FOCUS_LISTS_MANAGER_REPORT_SCHEMA_SUCCESS";
export const GetFocusListsManagerReportSchemaError = "GET_FOCUS_LISTS_MANAGER_REPORT_SCHEMA_ERROR";
export const CreateFocusListsManagerSavedReport = "CREATE_FOCUS_LIST_MANAGER_SAVED_REPORT";
export const CreateFocusListsManagerSavedReportSuccess =
  "CREATE_FOCUS_LISTS_MANAGER_SAVED_REPORT_SUCCESS";
export const CreateFocusListsManagerSavedReportError =
  "CREATE_FOCUS_LISTS_MANAGER_SAVED_REPORT_ERROR";
export const UpdateFocusListsManagerSavedReport = "UPDATE_FOCUS_LIST_MANAGER_SAVED_REPORT";
export const UpdateFocusListsManagerSavedReportSuccess =
  "UPDATG_FOCUS_LIST_MANAGER_SAVED_REPORT_SUCCESS";
export const UpdateFocusListsManagerSavedReportError =
  "UPDATE_FOCUS_LIST_MANAGER_SAVED_REPORT_ERROR";
export const DeleteFocusListsManagerSavedReport = "DELETE_FOCUS_LISTS_MANAGER_SAVED_REPORT";
export const DeleteFocusListsManagerSavedReportSuccess =
  "DELETE_FOCUS_LISTS_MANAGER_SAVED_REPORT_SUCCESS";
export const DeleteFocusListsManagerSavedReportError =
  "DELETE_FOCUS_LISTS_MANAGER_SAVED_REPORT_ERROR";
export const SetFocusListsManagerReportToSave = "SET_FOCUS_LISTS_MANAGER_REPORT_TO_SAVE";
export const ReSetFocusListsManagerReportToSave = "RE_SET_FOCUS_LISTS_MANAGER_REPORT_TO_SAVE";
export const ExportFocusListsManagerReport = "EXPORT_FOCUS_LISTS_MANAGER_REPORT";
export const ExportFocusListsManagerReportSuccess = "EXPORT_FOCUS_LISTS_MANAGER_REPORT_SUCCESS";
export const ExportFocusListsManagerReportError = "EXPORT_FOCUS_LISTS_MANAGER_REPORT_ERROR";
export const SetFocusListsManagerReportViewState = "SET_FOCUS_LISTS_MANAGER_REPORT_VIEW_STATE";

// Department Focus Lists
export const GetReportingFocusListsDepartmentDefaultReports =
  "REPORTING_FOCUS_LIST_DEPARTMENT_DEFAULT_REPORTS_REQUEST";
export const GetReportingFocusListsDepartmentDefaultReportsSuccess =
  "REPORTING_FOCUS_LIST_DEPARTMENT_DEFAULT_REPORTS_SUCCESS";
export const GetReportingFocusListsDepartmentDefaultReportsError =
  "REPORTING_FOCUS_LIST_DEPARTMENT_DEFAULT_REPORTS_ERROR";
export const GetReportingFocusListsDepartmentMyReports =
  "REPORTING_FOCUS_LIST_DEPARTMENT_MY_REPORTS_REQUEST";
export const GetReportingFocusListsDepartmentMyReportsSuccess =
  "REPORTING_FOCUS_LIST_DEPARTMENT_MY_REPORTS_SUCCESS";
export const GetReportingFocusListsDepartmentMyReportsError =
  "REPORTING_FOCUS_LIST_DEPARTMENT_MY_REPORTS_ERROR";
export const GetReportingFocusListsDepartmentReport =
  "REPORTING_FOCUS_LIST_DEPARTMENT_REPORT_REQUEST";
export const GetReportingFocusListsDepartmentReportSuccess =
  "REPORTING_FOCUS_LIST_DEPARTMENT_REPORT_SUCCESS";
export const GetReportingFocusListsDepartmentReportError =
  "REPORTING_FOCUS_LIST_DEPARTMENT_REPORT_ERROR";
export const GetFocusListsDepartmentReportSchema = "GET_FOCUS_LISTS_DEPARTMENT_REPORT_SCHEMA";
export const GetFocusListsDepartmentReportSchemaSuccess =
  "GET_FOCUS_LISTS_DEPARTMENT_REPORT_SCHEMA_SUCCESS";
export const GetFocusListsDepartmentReportSchemaError =
  "GET_FOCUS_LISTS_DEPARTMENT_REPORT_SCHEMA_ERROR";
export const CreateFocusListsDepartmentSavedReport = "CREATE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT";
export const CreateFocusListsDepartmentSavedReportSuccess =
  "CREATE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT_SUCCESS";
export const CreateFocusListsDepartmentSavedReportError =
  "CREATE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT_ERROR";
export const UpdateFocusListsDepartmentSavedReport = "UPDATE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT";
export const UpdateFocusListsDepartmentSavedReportSuccess =
  "UPDATE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT_SUCCESS";
export const UpdateFocusListsDepartmentSavedReportError =
  "UPDATE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT_ERROR";
export const DeleteFocusListsDepartmentSavedReport = "DELETE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT";
export const DeleteFocusListsDepartmentSavedReportSuccess =
  "DELETE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT_SUCCESS";
export const DeleteFocusListsDepartmentSavedReportError =
  "DELETE_FOCUS_LISTS_DEPARTMENT_SAVED_REPORT_ERROR";
export const ExportFocusListsDepartmentReport = "EXPORT_FOCUS_LISTS_DEPARTMENT_REPORT";
export const ExportFocusListsDepartmentReportSuccess =
  "EXPORT_FOCUS_LISTS_DEPARTMENT_REPORT_SUCCESS";
export const ExportFocusListsDepartmentReportError = "EXPORT_FOCUS_LISTS_DEPARTMENT_REPORT_ERROR";
export const SetFocusListsDepartmentReportToSave = "SET_FOCUS_LISTS_DEPARTMENT_REPORT_TO_SAVE";
export const ReSetFocusListsDepartmentReportToSave = "RE_SET_FOCUS_LISTS_DEPARTMENT_REPORT_TO_SAVE";
export const SetFocusListsDepartmentReportViewState =
  "SET_FOCUS_LISTS_DEPARTMENT_REPORT_VIEW_STATE";
export const GetFocusListDepartmentReportProfile = "GET_FOCUS_LIST_DEPARTMENT_REPORT_PROFILE";
export const GetFocusListDepartmentReportProfileSuccess =
  "GET_FOCUS_LIST_DEPARTMENT_REPORT_PROFILE_SUCCESS";
export const GetFocusListDepartmentReportProfileError =
  "GET_FOCUS_LIST_DEPARTMENT_REPORT_PROFILE_ERROR";
export const FocusListDepartmentReportProfileReset = "FOCUS_LIST_DEPARTMENT_REPORT_PROFILE_RESET";

// My Notifications
export const GetMyNotifications = "GET_MY_NOTIFICATIONS";
export const GetMyNotificationsSuccess = "GET_MY_NOTIFICATIONS_SUCCESS";
export const GetMyNotificationsError = "GET_MY_NOTIFICATIONS_ERROR";
export const SetMyNotificationsSearch = "SET_MY_NOTIFICATIONS_SEARCH";

// Absence Rate Trends
export const GetAbsenceRateTrendsDefaultReports = "GET_ABSENCE_RATE_TRENDS_DEFAULT_REPORTS";
export const GetAbsenceRateTrendsDefaultReportsSuccess =
  "GET_ABSENCE_RATE_TRENDS_DEFAULT_REPORTS_SUCCESS";
export const GetAbsenceRateTrendsDefaultReportsError =
  "GET_ABSENCE_RATE_TRENDS_DEFAULT_REPORTS_ERROR";
export const GetAbsenceRateTrendsMyReports = "GET_ABSENCE_RATE_TRENDS_MY_REPORTS";
export const GetAbsenceRateTrendsMyReportsSuccess = "GET_ABSENCE_RATE_TRENDS_MY_REPORTS_SUCCESS";
export const GetAbsenceRateTrendsMyReportsError = "GET_ABSENCE_RATE_TRENDS_MY_REPORTS_ERROR";
export const GetAbsenceRateTrendsReportData = "GET_ABSENCE_RATE_TRENDS_REPORT_DATA";
export const GetAbsenceRateTrendsReportDataSuccess = "GET_ABSENCE_RATE_TRENDS_REPORT_DATA_SUCCESS";
export const GetAbsenceRateTrendsReportDataError = "GET_ABSENCE_RATE_TRENDS_REPORT_DATA_ERROR";
export const GetAbsenceRateTrendsReportSchema = "GET_ABSENCE_RATE_TRENDS_REPORT_SCHEMA";
export const GetAbsenceRateTrendsReportSchemaSuccess =
  "GET_ABSENCE_RATE_TRENDS_REPORT_SCHEMA_SUCCESS";
export const GetAbsenceRateTrendsReportSchemaError = "GET_ABSENCE_RATE_TRENDS_REPORT_SCHEMA_ERROR";
export const CreateAbsenceRateTrendsReport = "CREATE_ABSENCE_RATE_TRENDS_REPORT";
export const CreateAbsenceRateTrendsReportSuccess = "CREATE_ABSENCE_RATE_TRENDS_REPORT_SUCCESS";
export const CreateAbsenceRateTrendsReportError = "CREATE_ABSENCE_RATE_TRENDS_REPORT_ERROR";
export const UpdateAbsenceRateTrendsReport = "UPDATE_ABSENCE_RATE_TRENDS_REPORT";
export const UpdateAbsenceRateTrendsReportSuccess = "UPDATE_ABSENCE_RATE_TRENDS_REPORT_SUCCESS";
export const UpdateAbsenceRateTrendsReportError = "UPDATE_ABSENCE_RATE_TRENDS_REPORT_ERROR";
export const DeleteAbsenceRateTrendsReport = "DELETE_ABSENCE_RATE_TRENDS_REPORT";
export const DeleteAbsenceRateTrendsReportSuccess = "DELETE_ABSENCE_RATE_TRENDS_REPORT_SUCCESS";
export const DeleteAbsenceRateTrendsReportError = "DELETE_ABSENCE_RATE_TRENDS_REPORT_ERROR";
export const SetAbsenceRateTrendsReportToSave = "SET_ABSENCE_RATE_TRENDS_REPORT_TO_SAVE";
export const ReSetAbsenceRateTrendsReportToSave = "RE_SET_ABSENCE_RATE_TRENDS_REPORT_TO_SAVE";
export const ExportAbsenceRateTrendsReport = "EXPORT_ABSENCE_RATE_TRENDS_REPORT";
export const ExportAbsenceRateTrendsReportSuccess = "EXPORT_ABSENCE_RATE_TRENDS_REPORT_SUCCESS";
export const ExportAbsenceRateTrendsReportError = "EXPORT_ABSENCE_RATE_TRENDS_REPORT_ERROR";
export const SetAbsenceRateTrendsReportViewState = "SET_ABSENCE_RATE_TRENDS_REPORT_VIEW_STATE";
// Trend Breakdown
export const GetAbsenceRateTrendBreakdown = "GET_ABSENCE_RATE_TREND_BREAK_DOWN";
export const GetAbsenceRateTrendBreakdownSuccess = "GET_ABSENCE_RATE_TREND_BREAK_DOWN_SUCCESS";
export const GetAbsenceRateTrendBreakdownError = "GET_ABSENCE_RATE_TREND_BREAK_DOWN_ERROR";
export const ResetAbsenceRateTrendBreakdown = "RESET_ABSENCE_RATE_TREND_BREAK_DOWN";
export const ExportAbsenceRateTrendBreakdown = "EXPORT_ABSENCE_RATE_TREND_BREAK_DOWN";
export const ExportAbsenceRateTrendBreakdownSuccess =
  "EXPORT_ABSENCE_RATE_TREND_BREAK_DOWN_SUCCESS";
export const ExportAbsenceRateTrendBreakdownError = "EXPORT_ABSENCE_RATE_TREND_BREAK_DOWN_ERROR";

// Complience Trends
export const GetComplianceTrendsDefaultReports = "GET_COMPLIANCE_TRENDS_DEFAULT_REPORTS";
export const GetComplianceTrendsDefaultReportsSuccess =
  "GET_COMPLIANCE_TRENDS_DEFAULT_REPORTS_SUCCESS";
export const GetComplianceTrendsDefaultReportsError = "GET_COMPLIANCE_TRENDS_DEFAULT_REPORTS_ERROR";
export const GetComplianceTrendsMyReports = "GET_COMPLIANCE_TRENDS_MY_REPORTS";
export const GetComplianceTrendsMyReportsSuccess = "GET_COMPLIANCE_TRENDS_MY_REPORTS_SUCCESS";
export const GetComplianceTrendsMyReportsError = "GET_COMPLIANCE_TRENDS_MY_REPORTS_ERROR";
export const GetComplianceTrendsReportData = "GET_COMPLIANCE_TRENDS_REPORT_DATA";
export const GetComplianceTrendsReportDataSuccess = "GET_COMPLIANCE_TRENDS_REPORT_DATA_SUCCESS";
export const GetComplianceTrendsReportDataError = "GET_COMPLIANCE_TRENDS_REPORT_DATA_ERROR";
export const GetComplianceTrendsReportSchema = "GET_COMPLIANCE_TRENDS_REPORT_SCHEMA";
export const GetComplianceTrendsReportSchemaSuccess = "GET_COMPLIANCE_TRENDS_REPORT_SCHEMA_SUCCESS";
export const GetComplianceTrendsReportSchemaError = "GET_COMPLIANCE_TRENDS_REPORT_SCHEMA_ERROR";
export const CreateComplianceTrendsReport = "CREATE_COMPLIANCE_TRENDS_REPORT";
export const CreateComplianceTrendsReportSuccess = "CREATE_COMPLIANCE_TRENDS_REPORT_SUCCESS";
export const CreateComplianceTrendsReportError = "CREATE_COMPLIANCE_TRENDS_REPORT_ERROR";
export const UpdateComplianceTrendsReport = "UPDATE_COMPLIANCE_TRENDS_REPORT";
export const UpdateComplianceTrendsReportSuccess = "UPDATE_COMPLIANCE_TRENDS_REPORT_SUCCESS";
export const UpdateComplianceTrendsReportError = "UPDATE_COMPLIANCE_TRENDS_REPORT_ERROR";
export const DeleteComplianceTrendsReport = "DELETE_COMPLIANCE_TRENDS_REPORT";
export const DeleteComplianceTrendsReportSuccess = "DELETE_COMPLIANCE_TRENDS_REPORT_SUCCESS";
export const DeleteComplianceTrendsReportError = "DELETE_COMPLIANCE_TRENDS_REPORT_ERROR";
export const SetComplianceTrendsReportToSave = "SET_COMPLIANCE_TRENDS_REPORT_TO_SAVE";
export const ReSetComplianceTrendsReportToSave = "RE_SET_COMPLIANCE_TRENDS_REPORT_TO_SAVE";
export const SetComplianceReportViewState = "SET_COMPLIANCE_REPORT_VIEW_STATE";
export const ExportComplianceTrendsReport = "EXPORT_COMPLIANCE_TRENDS_REPORT";
export const ExportComplianceTrendsReportSuccess = "EXPORT_COMPLIANCE_TRENDS_REPORT_SUCCESS";
export const ExportComplianceTrendsReportError = "EXPORT_COMPLIANCE_TRENDS_REPORT_ERROR";

// SLA Performance Trends
export const GetSlaPerformanceTrendsDefaultReports = "GET_SLA_PERFORMANCE_TRENDS_DEFAULT_REPORTS";
export const GetSlaPerformanceTrendsDefaultReportsSuccess =
  "GET_SLA_PERFORMANCE_TRENDS_DEFAULT_REPORTS_SUCCESS";
export const GetSlaPerformanceTrendsDefaultReportsError =
  "GET_SLA_PERFORMANCE_TRENDS_DEFAULT_REPORTS_ERROR";
export const GetSlaPerformanceTrendsMyReports = "GET_SLA_PERFORMANCE_TRENDS_MY_REPORTS";
export const GetSlaPerformanceTrendsMyReportsSuccess =
  "GET_SLA_PERFORMANCE_TRENDS_MY_REPORTS_SUCCESS";
export const GetSlaPerformanceTrendsMyReportsError = "GET_SLA_PERFORMANCE_TRENDS_MY_REPORTS_ERROR";
export const GetSlaPerformanceTrendsReportData = "GET_SLA_PERFORMANCE_TRENDS_REPORT_DATA";
export const GetSlaPerformanceTrendsReportDataSuccess =
  "GET_SLA_PERFORMANCE_TRENDS_REPORT_DATA_SUCCESS";
export const GetSlaPerformanceTrendsReportDataError =
  "GET_SLA_PERFORMANCE_TRENDS_REPORT_DATA_ERROR";
export const ToggleSlaPerformanceTrendsEditReportModal =
  "TOGGLE_SLA_PERFORMANCE_TRENDS_EDIT_REPORT_MODAL";
export const UpdateSlaPerformanceTrendsReport = "UPDATE_SLA_PERFORMANCE_TRENDS_REPORT";
export const UpdateSlaPerformanceTrendsReportSuccess =
  "UPDATE_SLA_PERFORMANCE_TRENDS_REPORT_SUCCESS";
export const UpdateSlaPerformanceTrendsReportError = "UPDATE_SLA_PERFORMANCE_TRENDS_REPORT_ERROR";

// Absence Reason Trends
export const GetAbsenceReasonTrendsDefaultReports = "GET_ABSENCE_REASON_TRENDS_DEFAULT_REPORTS";
export const GetAbsenceReasonTrendsDefaultReportsSuccess =
  "GET_ABSENCE_REASON_TRENDS_DEFAULT_REPORTS_SUCCESS";
export const GetAbsenceReasonTrendsDefaultReportsError =
  "GET_ABSENCE_REASON_TRENDS_DEFAULT_REPORTS_ERROR";
export const GetAbsenceReasonTrendsMyReports = "GET_ABSENCE_REASON_TRENDS_MY_REPORTS";
export const GetAbsenceReasonTrendsMyReportsSuccess =
  "GET_ABSENCE_REASON_TRENDS_MY_REPORTS_SUCCESS";
export const GetAbsenceReasonTrendsMyReportsError = "GET_ABSENCE_REASON_TRENDS_MY_REPORTS_ERROR";
export const GetAbsenceReasonTrendsReportData = "GET_ABSENCE_REASON_TRENDS_REPORT_DATA";
export const GetAbsenceReasonTrendsReportDataSuccess =
  "GET_ABSENCE_REASON_TRENDS_REPORT_DATA_SUCCESS";
export const GetAbsenceReasonTrendsReportDataError = "GET_ABSENCE_REASON_TRENDS_REPORT_DATA_ERROR";
export const GetAbsenceProfile = "GET_ABSENCE_PROFILE";
export const GetAbsenceProfileSuccess = "GET_ABSENCE_PROFILE_SUCCESS";
export const GetAbsenceProfileError = "GET_ABSENCE_PROFILE_ERROR";
export const ClearAbsenceProfile = "CLEAR_ABSENCE_PROFILE";
export const GetAbsenceReasonTrendsReportSchema = "GET_ABSENCE_REASON_TRENDS_REPORT_SCHEMA";
export const GetAbsenceReasonTrendsReportSchemaSuccess =
  "GET_ABSENCE_REASON_TRENDS_REPORT_SCHEMA_SUCCESS";
export const GetAbsenceReasonTrendsReportSchemaError =
  "GET_ABSENCE_REASON_TRENDS_REPORT_SCHEMA_ERROR";
export const SetAbsenceReasonTrendsReportViewState = "SET_ABSENCE_REASON_TRENDS_REPORT_VIEW_STATE";
export const CreateAbsenceReasonTrendsReport = "CREATE_ABSENCE_REASON_TRENDS_REPORT";
export const CreateAbsenceReasonTrendsReportSuccess = "CREATE_ABSENCE_REASON_TRENDS_REPORT_SUCCESS";
export const CreateAbsenceReasonTrendsReportError = "CREATE_ABSENCE_REASON_TRENDS_REPORT_ERROR";
export const UpdateAbsenceReasonTrendsReport = "UPDATE_ABSENCE_REASON_TRENDS_REPORT";
export const UpdateAbsenceReasonTrendsReportSuccess = "UPDATE_ABSENCE_REASON_TRENDS_REPORT_SUCCESS";
export const UpdateAbsenceReasonTrendsReportError = "UPDATE_ABSENCE_REASON_TRENDS_REPORT_ERROR";
export const DeleteAbsenceReasonTrendsReport = "DELETE_ABSENCE_REASON_TRENDS_REPORT";
export const DeleteAbsenceReasonTrendsReportSuccess = "DELETE_ABSENCE_REASON_TRENDS_REPORT_SUCCESS";
export const DeleteAbsenceReasonTrendsReportError = "DELETE_ABSENCE_REASON_TRENDS_REPORT_ERROR";
export const SetAbsenceReasonTrendsReportToSave = "SET_ABSENCE_REASON_TRENDS_REPORT_TO_SAVE";
export const ReSetAbsenceReasonTrendsReportToSave = "RE_SET_ABSENCE_REASON_TRENDS_REPORT_TO_SAVE";
export const ExportAbsenceReasonTrendsReport = "EXPORT_ABSENCE_REASON_TRENDS_REPORT";
export const ExportAbsenceReasonTrendsReportSuccess = "EXPORT_ABSENCE_REASON_TRENDS_REPORT_SUCCESS";
export const ExportAbsenceReasonTrendsReportError = "EXPORT_ABSENCE_REASON_TRENDS_REPORT_ERROR";

// Employee Details
export const GetEmployeeDetails = "GET_EMPLOYEE_DETAILS";
export const GetEmployeeDetailsSuccess = "GET_EMPLOYEE_DETAILS_SUCCESS";
export const GetEmployeeDetailsError = "GET_EMPLOYEE_DETAILS_ERROR";

// Manager Details
export const GetManagerDetails = "GET_MANAGER_DETAILS";
export const GetManagerDetailsSuccess = "GET_MANAGER_DETAILS_SUCCESS";
export const GetManagerDetailsError = "GET_MANAGER_DETAILS_ERROR";
export const GetManagerDetailsLogins = "GET_MANAGER_DETAILS_LOGINS";
export const GetManagerDetailsLoginsSuccess = "GET_MANAGER_DETAILS_LOGINS_SUCCESS";
export const GetManagerDetailsLoginsError = "GET_MANAGER_DETAILS_LOGINS_ERROR";
export const GetManagerDetailsTasks = "GET_MANAGER_DETAILS_TASKS";
export const GetManagerDetailsTasksSuccess = "GET_MANAGER_DETAILS_TASKS_SUCCESS";
export const GetManagerDetailsTasksError = "GET_MANAGER_DETAILS_TASKS_ERROR";

// FirstCara Index
export const CreateAbsenceTrendsReport = "CREATE_ABSENCE_TRENDS_REPORT";
export const CreateAbsenceTrendsReportSuccess = "CREATE_ABSENCE_TRENDS_REPORT_SUCCESS";
export const CreateAbsenceTrendsReportError = "CREATE_ABSENCE_TRENDS_REPORT_ERROR";

// Manager Compliance
export const GetManagerCompliance = "GET_MANAGER_COMPLIANCE";
export const GetManagerComplianceSuccess = "GET_MANAGER_COMPLIANCE_SUCCESS";
export const GetManagerComplianceError = "GET_MANAGER_COMPLIANCE_ERROR";

// Referral Tracker
export const GetSupplierNewReferrals = "GET_SUPPLIER_NEW_REFERRALS";
export const GetSupplierNewReferralsSuccess = "GET_SUPPLIER_NEW_REFERRALS_SUCCESS";
export const GetSupplierNewReferralsError = "GET_SUPPLIER_NEW_REFERRALS_ERROR";
export const GetSupplierActiveReferrals = "GET_SUPPLIER_ACTIVE_REFERRALS";
export const GetSupplierActiveReferralsSuccess = "GET_SUPPLIER_ACTIVE_REFERRALS_SUCCESS";
export const GetSupplierActiveReferralsError = "GET_SUPPLIER_ACTIVE_REFERRALS_ERROR";
export const GetSupplierClosedReferrals = "GET_SUPPLIER_CLOSED_REFERRALS";
export const GetSupplierClosedReferralsSuccess = "GET_SUPPLIER_CLOSED_REFERRALS_SUCCESS";
export const GetSupplierClosedReferralsError = "GET_SUPPLIER_CLOSED_REFERRALS_ERROR";
export const GetSupplierReferralDetails = "GET_SUPPLIER_REFERRAL_DETAILS";
export const GetSupplierReferralDetailsSuccess = "GET_SUPPLIER_REFERRAL_DETAILS_SUCCESS";
export const GetSupplierReferralDetailsError = "GET_SUPPLIER_REFERRAL_DETAILS_ERROR";
export const ToggleSupplierReferralDetailsModal = "TOGGLE_SUPPLIER_REFERRAL_DETAILS_MODAL";
export const SubmitSupplierReferralStatus = "SUBMIT_SUPPLIER_REFERRAL_STATUS";
export const SubmitSupplierReferralStatusSuccess = "SUBMIT_SUPPLIER_REFERRAL_STATUS_SUCCESS";
export const SubmitSupplierReferralStatusError = "SUBMIT_SUPPLIER_REFERRAL_STATUS_ERROR";
export const GetSupplierClosedReferralsStatuses = "GET_SUPPLIER_CLOSED_REFERRALS_STATUSES";
export const GetSupplierClosedReferralsStatusesSuccess =
  "GET_SUPPLIER_CLOSED_REFERRALS_STATUSES_SUCCESS";
export const GetSupplierClosedReferralsStatusesError =
  "GET_SUPPLIER_CLOSED_REFERRALS_STATUSES_ERROR";
// TODO show loading bar - GetSupplierClosedReferralsExport
export const GetSupplierClosedReferralsExport = "GET_SUPPLIER_CLOSED_REFERRALS_EXPORT";
export const GetSupplierClosedReferralsExportSuccess =
  "GET_SUPPLIER_CLOSED_REFERRALS_EXPORT_SUCCESS";
export const GetSupplierClosedReferralsExportError = "GET_SUPPLIER_CLOSED_REFERRALS_EXPORT_ERROR";
//RTW
export const GetRTWReferralDetails = "GET_RTW_REFERRAL_DETAILS";
export const GetRTWReferralDetailsSuccess = "GET_RTW_REFERRAL_DETAILS_SUCCESS";
export const GetRTWReferralDetailsError = "GET_RTW REFERRAL_DETAILS_ERROR";
export const ToggleRTWReferralDetailsModal = "TOGGLE_RTW_REFERRAL_DETAILS_MODAL";
export const SubmitRTWReferralData = "SUBMIT_RTW_REFERRAL_DATA";
export const SubmitRTWReferralDataSuccess = "SUBMIT_RTW_REFERRAL_DATA_SUCCESS";
export const SubmitRTWReferralDataError = "SUBMIT_RTW_REFERRAL_DATA_ERROR";
//LOG
export const GetLogReferralDetails = "GET_LOG_REFERRAL_DETAILS";
export const GetLogReferralDetailsSuccess = "GET_LOG_REFERRAL_DETAILS_SUCCESS";
export const GetLogReferralDetailsError = "GET_LOG_REFERRAL_DETAILS_ERROR";
export const ToggleLogReferralDetailsModal = "TOGGLE_LOG_REFERRAL_DETAILS_MODAL";
export const SubmitLogReferralData = "SUBMIT_LOG_REFERRAL_DATA";
export const SubmitLogReferralDataSuccess = "SUBMIT_LOG_REFERRAL_DATA_SUCCESS";
export const SubmitLogReferralDataError = "SUBMIT_LOG_REFERRAL_DATA_ERROR";
export const GetLogReferralOutcomeOptions = "GET_LOG_REFERRAL_OUTCOME_OPTIONS";
export const SetReferralCommonData = "SET_REFERRAL_COMMON_DATA";
export const GetLogReferralOutcomeOptionsError = "GET_LOG_REFERRAL_OUTCOME_OPTIONS_ERROR";

//STATUS
export const ToggleStatusReferralDetailsModal = "TOGGLE_STATUS_REFERRAL_DETAILS_MODAL";

// My Tasks
export const GetOutstandingTasks = "GET_OUTSTANDING_TASKS";
export const GetOutstandingTasksSuccess = "GET_OUTSTANDING_TASKS_SUCCESS";
export const GetOutstandingTasksError = "GET_OUTSTANDING_TASKS_ERROR";

export const GetAbsenceTask = "GET_ABSENCE_TASK";
export const GetAbsenceTaskSuccess = "GET_ABSENCE_TASK_SUCCESS";
export const GetAbsenceTaskError = "GET_ABSENCE_TASK_ERROR";
export const GetManagerLedReferralTask = "GET_MANAGER_LED_REFERRAL_TASK";
export const GetManagerLedReferralTaskSuccess = "GET_MANAGER_LED_REFERRAL_TASK_SUCCESS";
export const GetManagerLedReferralTaskError = "GET_MANAGER_LED_REFERRAL_TASK_ERROR";
export const SubmitManagerLedReferralDraft = "SUBMIT_MANAGER_LED_REFERRAL_DRAFT";
export const SubmitManagerLedReferralDraftSuccess = "SUBMIT_MANAGER_LED_REFERRAL_DRAFT_SUCCESS";
export const SubmitManagerLedReferralDraftError = "SUBMIT_MANAGER_LED_REFERRAL_DRAFT_ERROR";
export const UpdateManagerLedReferralDraft = "UPDATE_MANAGER_LED_REFERRAL_DRAFT";
export const UpdateManagerLedReferralDraftSuccess = "UPDATE_MANAGER_LED_REFERRAL_DRAFT_SUCCESS";
export const UpdateManagerLedReferralDraftError = "UPDATE_MANAGER_LED_REFERRAL_DRAFT_ERROR";
export const GetAbsenceTaskSchema = "GET_ABSENCE_TASK_SCHEMA";
export const GetAbsenceTaskSchemaSuccess = "GET_ABSENCE_TASK_SCHEMA_SUCCESS";
export const GetAbsenceTaskSchemaError = "GET_ABSENCE_TASK_SCHEMA_ERROR";
export const SubmitAbsenceTask = "SUBMIT_ABSENCE_TASK";
export const SubmitAbsenceTaskSuccess = "SUBMIT_ABSENCE_TASK_SUCCESS";
export const SubmitAbsenceTaskError = "SUBMIT_ABSENCE_TASK_ERROR";
export const GetRtwInterviewTask = "GET_RTW_INTERVIEW_TASK";
export const GetRtwInterviewTaskSuccess = "GET_RTW_INTERVIEW_TASK_SUCCESS";
export const GetRtwInterviewTaskError = "GET_RTW_INTERVIEW_TASK_ERROR";
export const SaveDraftRTWInterviewTask = "SAVE_DRAFT_RTW_INTERVIEW_TASK";
export const SaveDraftRTWInterviewTaskSuccess = "SAVE_DRAFT_RTW_INTERVIEW_TASK_SUCCESS";
export const SaveDraftRTWInterviewTaskError = "SAVE_DRAFT_RTW_INTERVIEW_TASK_ERROR";
export const SubmitRTWInterviewTask = "SUBMIT_RTW_INTERVIEW_TASK";
export const SubmitRTWInterviewTaskSuccess = "SUBMIT_RTW_INTERVIEW_TASK_SUCCESS";
export const SubmitRTWInterviewTaskError = "SUBMIT_RTW_INTERVIEW_TASK_ERROR";
export const ToggleLateSubmissionModal = "TOGGLE_LATE_SUBMISSION_MODAL";
export const SetRtwInterviewTaskHistory = "SET_RTW_INTERVIEW_TASK_HISTORY";
export const SetMyTasksSearch = "SET_MY_TASKS_SEARCH";
export const SetMyTasksType = "SET_MY_TASKS_TYPE";

export const ToggleCancelTaskModal = "TOGGLE_CANCEL_TASK_MODAL";
export const SubmitCancelTask = "SUBMIT_CANCEL_TASK";
export const SubmitCancelTaskSuccess = "SUBMIT_CANCEL_TASK_SUCCESS";
export const SubmitCancelTaskError = "SUBMIT_CANCEL_TASK_ERROR";

// Absence Details
export const GetAbsenceRecordSearchFiltersSchema = "GET_ABSENCE_RECORD_SEARCH_FILTERS_SCHEMA";
export const GetAbsenceRecordSearchFiltersSchemaSuccess =
  "GET_ABSENCE_RECORD_SEARCH_FILTERS_SCHEMA_SUCCESS";
export const GetAbsenceRecordSearchFiltersSchemaError =
  "GET_ABSENCE_RECORD_SEARCH_FILTERS_SCHEMA_ERROR";
export const CreateAbsenceSavedReport = "CREATE_ABSENCE_SAVED_REPORT";
export const CreateAbsenceSavedReportSuccess = "CREATE_ABSENCE_SAVED_REPORT_SUCCESS";
export const CreateAbsenceSavedReportError = "CREATE_ABSENCE_SAVED_REPORT_ERROR";
export const GetAbsenceDefaultReports = "GET_ABSENCE_DEFAULT_REPORTS";
export const GetAbsenceDefaultReportsSuccess = "GET_ABSENCE_DEFAULT_REPORTS_SUCCESS";
export const GetAbsenceDefaultReportsError = "GET_ABSENCE_DEFAULT_REPORTS_ERROR";
export const GetAbsenceMySavedReports = "GET_ABSENCE_MY_SAVED_REPORTS";
export const GetAbsenceMySavedReportsSuccess = "GET_ABSENCE_MY_SAVED_REPORTS_SUCCESS";
export const GetAbsenceMySavedReportsError = "GET_ABSENCE_MY_SAVED_REPORTS_ERROR";
export const GetAbsenceDetailsReport = "GET_ABSENCE_DETAILS_REPORT";
export const GetAbsenceDetailsReportSuccess = "GET_ABSENCE_DETAILS_REPORT_SUCCESS";
export const GetAbsenceDetailsReportError = "GET_ABSENCE_DETAILS_REPORT_ERROR";
export const DeleteSavedAbsenceDetailsReport = "DELETE_SAVED_ABSENCE_DETAILS_REPORT";
export const DeleteSavedAbsenceDetailsReportSuccess = "DELETE_SAVED_ABSENCE_DETAILS_REPORT_SUCCESS";
export const DeleteSavedAbsenceDetailsReportError = "DELETE_SAVED_ABSENCE_DETAILS_REPORT_ERROR";
export const UpdateSavedAbsenceDetailsReport = "UPDATE_SAVED_ABSENCE_DETAILS_REPORT";
export const UpdateSavedAbsenceDetailsReportSuccess = "UPDATE_SAVED_ABSENCE_DETAILS_REPORT_SUCCESS";
export const UpdateSavedAbsenceDetailsReportError = "UPDATE_SAVED_ABSENCE_DETAILS_REPORT_ERROR";
export const GetAbsenceDetailsCharts = "GET_ABSENCE_DETAILS_CHARTS";
export const GetAbsenceDetailsChartsSuccess = "GET_ABSENCE_DETAILS_CHARTS_SUCCESS";
export const GetAbsenceDetailsChartsError = "GET_ABSENCE_DETAILS_CHARTS_ERROR";
export const ExportAbsenceDetailsReport = "EXPORT_ABSENCE_DETAILS_REPORT";
export const ExportAbsenceDetailsReportSuccess = "EXPORT_ABSENCE_DETAILS_REPORT_SUCCESS";
export const ExportAbsenceDetailsReportError = "EXPORT_ABSENCE_DETAILS_REPORT_ERROR";
export const SetAbsenceDetailsReportToSave = "SET_ABSENCE_DETAILS_REPORT_TO_SAVE";
export const ReSetAbsenceDetailsReportToSave = "RE_SET_ABSENCE_DETAILS_REPORT_TO_SAVE";
export const SetAbsenceDetailsReportViewState = "SET_ABSENCE_DETAILS_REPORT_VIEW_STATE";

// Report modals
export const ToggleSaveReportModal = "TOGGLE_SAVE_REPORT_MODAL";
export const ToggleAddEditReportModal = "TOGGLE_ADD_EDIT_REPORT_MODAL";
export const ToggleScheduleReportSettingsModal = "TOGGLE_SCHEDULE_REPORT_SETTINGS_MODAL";

export const ToggleMiLogModal = "TOGGLE_MI_LOG_MODAL";
export const ToggleMiShareModal = "TOGGLE_MI_SHARE_MODAL";

export const GetScheduledReportData = "GET_SCHEDULED_REPORT_DATA";
export const GetScheduledReportDataSuccess = "GET_SCHEDULED_REPORT_DATA_SUCCESS";
export const GetScheduledReportDataError = "GET_SCHEDULED_REPORT_DATA_ERROR";

export const SubmitScheduleReportSettings = "SUBMIT_SCHEDULE_REPORT_SETTINGS";
export const SubmitScheduleReportSettingsSuccess = "SUBMIT_SCHEDULE_REPORT_SETTINGS_SUCCESS";
export const SubmitScheduleReportSettingsError = "SUBMIT_SCHEDULE_REPORT_SETTINGS_ERROR";
export const SetScheduledReportSettingsModalData = "SET_SCHEDULED_REPORT_SETTINGS_MODAL_DATA";

export const LogRunReport = "LOG_RUN_REPORT";
export const LogRunReportSuccess = "LOG_RUN_REPORT_SUCCESS";
export const LogRunReportError = "LOG_RUN_REPORT_ERROR";

//Data Forecasts
export const ExportTop10Department = "EXPORT_TOP_10_DEPARTMENT";
export const GetDataForecasts = "GET_DATA_FORECASTS";
export const GetDataForecastsSuccess = "GET_DATA_FORECASTS_SUCCESS";
export const GetDataForecastsError = "GET_DATA_FORECASTS_ERROR";

export const GetEmployeeRiskSummary = "GET_EMPLOYEE_RISK_SUMMARY";
export const GetEmployeeRiskSummarySuccess = "GET_EMPLOYEE_RISK_SUMMARY_SUCCESS";
export const GetEmployeeRiskSummaryError = "GET_EMPLOYEE_RISK_SUMMARY_ERROR";

export const GetAbsenceDurationsSummary = "GET_ABSENCE_DURATIONS_SUMMARY";
export const GetAbsenceDurationsSummarySuccess = "GET_ABSENCE_DURATIONS_SUMMARY_SUCCESS";
export const GetAbsenceDurationsSummaryError = "GET_ABSENCE_DURATIONS_SUMMARY_ERROR";

export const GetWorkForceHealth = "GET_WORK_FORCE_HEALTH";
export const GetWorkForceHealthSuccess = "GET_WORK_FORCE_HEALTH_SUCCESS";
export const GetWorkForceHealthError = "GET_WORK_FORCE_HEALTH_ERROR";
export const ExportWorkForceReport = "EXPORT_WORK_FORCE_REPORT";
export const ExportWorkForceReportSuccess = "EXPORT_WORK_FORCE_REPORT_SUCCESS";
export const ExportWorkForceReportError = "EXPORT_WORK_FORCE_REPORT_ERROR";

export const GetCarePlansReport = "GET_CARE_PLANS_REPORT";
export const GetCarePlansReportSuccess = "GET_CARE_PLANS_REPORT_SUCCESS";
export const GetCarePlansReportError = "GET_CARE_PLANS_REPORT_ERROR";
export const ExportCarePlansReport = "EXPORT_CARE_PLANS_REPORT";
export const ExportCarePlansReportSuccess = "EXPORT_CARE_PLANS_REPORT_SUCCESS";
export const ExportCarePlansReportError = "EXPORT_CARE_PLANS_REPORT_ERROR";

export const GetWellbeingAdviceReport = "GET_WELLBEING_ADVICE_REPORT";
export const GetWellbeingAdviceReportSuccess = "GET_WELLBEING_ADVICE_REPORT_SUCCESS";
export const GetWellbeingAdviceReportError = "GET_WELLBEING_ADVICE_REPORT_ERROR";
export const ExportWellbeingAdviceReport = "EXPORT_WELLBEING_ADVICE_REPORT";
export const ExportWellbeingAdviceReportSuccess = "EXPORT_WELLBEING_ADVICE_REPORT_SUCCESS";
export const ExportWellbeingAdviceReportError = "EXPORT_WELLBEING_ADVICE_REPORT_ERROR";

export const GetNurseAssessmentsReport = "GET_NURSE_ASSESSMENTS_REPORT";
export const GetNurseAssessmentsReportSuccess = "GET_NURSE_ASSESSMENTS_REPORT_SUCCESS";
export const GetNurseAssessmentsReportError = "GET_NURSE_ASSESSMENTS_REPORT_ERROR";
export const ExportNurseAssessmentsReport = "EXPORT_NURSE_ASSESSMENTS_REPORT";
export const ExportNurseAssessmentsReportSuccess = "EXPORT_NURSE_ASSESSMENTS_REPORT_SUCCESS";
export const ExportNurseAssessmentsReportError = "EXPORT_NURSE_ASSESSMENTS_REPORT_ERROR";

export const GetProvidersReport = "GET_PROVIDERS_REPORT";
export const GetProvidersReportSuccess = "GET_PROVIDERS_REPORT_SUCCESS";
export const GetProvidersReportError = "GET_PROVIDERS_REPORT_ERROR";
export const ExportProvidersReport = "EXPORT_PROVIDERS_REPORT";
export const ExportProvidersReportSuccess = "EXPORT_PROVIDERS_REPORT_SUCCESS";
export const ExportProvidersReportError = "EXPORT_PROVIDERS_REPORT_ERROR";

export const GetCoverageData = "GET_COVERAGE_DATA";
export const GetCoverageDataSuccess = "GET_COVERAGE_DATA_SUCCESS";
export const GetCoverageDataError = "GET_COVERAGE_DATA_ERROR";
export const ExportCoverageData = "EXPORT_COVERAGE_DATA";
export const ExportCoverageDataSuccess = "EXPORT_COVERAGE_DATA_SUCCESS";
export const ExportCoverageDataError = "EXPORT_COVERAGE_DATA_ERROR";

export const GetCoverageChartData = "GET_COVERAGE_CHART_DATA";
export const GetCoverageChartDataSuccess = "GET_COVERAGE_CHART_DATA_SUCCESS";
export const GetCoverageChartDataError = "GET_COVERAGE_CHART_DATA_ERROR";

// Outcomes
export const GetReferralOutcomesReport = "GET_REFERRAL_OUTCOMES_REPORT";
export const GetReferralOutcomesReportSuccess = "GET_REFERRAL_OUTCOMES_REPORT_SUCCESS";
export const GetReferralOutcomesReportError = "GET_REFERRAL_OUTCOMES_REPORT_ERROR";
export const ExportReferralOutcomesReport = "EXPORT_REFERRAL_OUTCOMES_REPORT";
export const ExportReferralOutcomesReportSuccess = "EXPORT_REFERRAL_OUTCOMES_REPORT_SUCCESS";
export const ExportReferralOutcomesReportError = "EXPORT_REFERRAL_OUTCOMES_REPORT_ERROR";
// Manager KPI
export const GetManagerKpiReport = "GET_MANAGER_KPI_REPORT";
export const GetManagerKpiReportSuccess = "GET_MANAGER_KPI_REPORT_SUCCESS";
export const GetManagerKpiReportError = "GET_MANAGER_KPI_REPORT_ERROR";
export const ExportManagerKpiReport = "EXPORT_MANAGER_KPI_REPORT";
export const ExportManagerKpiReportSuccess = "EXPORT_MANAGER_KPI_REPORT_SUCCESS";
export const ExportManagerKpiReportError = "EXPORT_MANAGER_KPI_REPORT_ERROR";

// Compliance KPI
export const GetKpiComplianceReport = "GET_KPI_COMPLIANCE_REPORT";
export const GetKpiComplianceReportSuccess = "GET_KPI_COMPLIANCE_REPORT_SUCCESS";
export const GetKpiComplianceReportError = "GET_KPI_COMPLIANCE_REPORT_ERROR";
export const ExportKpiComplianceReport = "EXPORT_KPI_COMPLIANCE_REPORT";
export const ExportKpiComplianceReportSuccess = "EXPORT_KPI_COMPLIANCE_REPORT_SUCCESS";
export const ExportKpiComplianceReportError = "EXPORT_KPI_COMPLIANCE_REPORT_ERROR";
